'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchLocationDetails = exports.searchLocationAutocomplete = exports.searchLayoutByName = exports.locationAutocomplete = exports.keywordAutocomplete = exports.searchSchedules = undefined;

var _sagaTools = require('@classpass/saga-tools');

var _verify = require('helpers/verify');

var _SearchLayout = require('features/Search/models/SearchLayout');

var searchSchedules = exports.searchSchedules = (0, _sagaTools.makeEntityScaffold)('SAGA.API.SEARCH_SCHEDULES', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return options.cursor ? client.search.getSchedulesByCursor(options) : client.search.schedules(options);
}, {
  defaultKey: function defaultKey(client, options) {
    return options.page ? 'page_' + options.page : 'page_1';
  }
});

var keywordAutocomplete = exports.keywordAutocomplete = (0, _sagaTools.makeEntityScaffold)('SAGA.API.KEYWORD_AUTOCOMPLETE', function (client, query, location) {
  return client.search.keyword.autocomplete({
    query: query,
    location: location
  }).then(function (data) {
    return data.data.results;
  });
}, { defaultKey: 1 });

var locationAutocomplete = exports.locationAutocomplete = (0, _sagaTools.makeEntityScaffold)('SAGA.API.LOCATION_AUTOCOMPLETE', function (client, query) {
  return client.search.location.autocomplete({ query: query });
}, { defaultKey: 1 });

var searchLayoutByName = exports.searchLayoutByName = (0, _sagaTools.makeEntityScaffold)('SAGA.API.SEARCH_LAYOUT', function (client, layoutName) {
  var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return client.search.getLayout(layoutName, payload).then(function (_ref) {
    var modules = _ref.data.modules;
    return new _SearchLayout.SearchLayout(modules, {
      layoutName: layoutName,
      distanceUnit: config.distanceUnit
    });
  });
}, { defaultKey: 1 });

var searchLocationAutocomplete = exports.searchLocationAutocomplete = (0, _sagaTools.makeEntityScaffold)('SAGA.API.SEARCH_LOCATION_AUTOCOMPLETE', function (client) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      query = _ref2.query,
      near = _ref2.near,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? 'geocode' : _ref2$type;

  return client.search.location.autocomplete({
    autocomplete_type: type,
    near: (0, _verify.isEmpty)(near) ? null : {
      lat: near.lat,
      lon: near.lon
    },
    query: query
  }).then(function (data) {
    return data.data;
  });
});

var searchLocationDetails = exports.searchLocationDetails = (0, _sagaTools.makeEntityScaffold)('SAGA.API.SEARCH_LOCATION_DETAILS', function (client, placeId) {
  return client.search.location.details(placeId).then(function (data) {
    return data.data;
  });
}, { defaultKey: 1 });